import React from 'react';
import { audience } from '../../data/content';
export function Audience() {
  return <section className="bg-mist py-12 lg:py-20" aria-labelledby="audience-title" style={{
    backgroundColor: "#EAF5F2",
    backgroundImage: "none"
  }} data-id="element-191" data-mp="1rnsl0ans3hqj">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-192" data-mp="1dy8lretep2lz">
        <h2 id="audience-title" className="font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-193" data-mp="1hxr1zxaa8pih">
          ¿Para quién es <span className="text-brand-600" data-id="element-194" data-mp="25lqub1n8snz6">REACTIVA TU CUERPO™</span>?
        </h2>
        <p className="mx-auto mt-2 max-w-2xl text-[15px] leading-relaxed text-ink-soft sm:text-lg" style={{
        fontSize: "18px",
        fontWeight: "700",
        fontStyle: "italic",
        color: "#087F7B"
      }} data-id="element-195" data-mp="2amejrivtowra">
          Está pensado para personas que quieran incorporar este campo de trabajo a su actividad y a quienes ya trabajan con adultos mayores.
        </p>
        <ul className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-196" data-mp="q7cwopgc4lif">
          {audience.map((a, i) => {
          const Icon = a.icon;
          const isLast = i === audience.length - 1;
          return <li key={a.label} className={`flex items-center gap-2 rounded-full px-3.5 py-2 text-sm font-semibold ${isLast ? 'bg-brand-600 text-white' : 'bg-white text-ink ring-1 ring-brand-100'}`} data-id="element-197" data-mp="unqd0u6gkzh1" data-mpi={i}>
                <Icon className={`h-4 w-4 shrink-0 ${isLast ? 'text-white' : 'text-brand-600'}`} aria-hidden="true" data-id="element-198" data-mp="14kv2p3zijd2l" />
                {a.label}
              </li>;
        })}
        </ul>
        <div className="mx-auto mt-8 grid max-w-3xl gap-2.5 text-left sm:grid-cols-2" data-id="element-199" data-mp="1dm2lsetgk7c3">
          <p className="rounded-2xl bg-white p-4 font-display text-sm font-extrabold uppercase leading-snug tracking-wide text-ink ring-1 ring-brand-100" data-id="element-200" data-mp="1dk8bduftbxm9">
            Si ya trabajás con adultos mayores, <span className="text-brand-600" data-id="element-201" data-mp="1ndywcpcqdpx7">sumá nuevas herramientas.</span>
          </p>
          <p className="rounded-2xl bg-brand-950 p-4 font-display text-sm font-extrabold uppercase leading-snug tracking-wide text-white" data-id="element-202" data-mp="21bx1r592qc0k">
            Si todavía no trabajás con ellos, <span className="text-sun" data-id="element-203" data-mp="24ekxsfh40ee4">preparate para incorporar este campo a tu perfil.</span>
          </p>
        </div>
      </div>
    </section>;
}